import Breadcrumb from "@/components/layout/Breadcrumb";
import Header from "@/components/layout/Header";
import Sidebar from "@/components/layout/Sidebar";
import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_private")({
  beforeLoad: ({ context }) => {
    if (!context.auth.isAuthenticated) {
      throw redirect({ to: "/login" });
    }
  },
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <>
      <Sidebar />
      <Header />
      <div className="container mx-auto flex flex-col min-h-[calc(100vh-4rem)] p-6 lg:ps-16">
        <Breadcrumb />
        <div className="flex-1 flex flex-col space-y-6">
          <Outlet />
        </div>
      </div>
    </>
  );
}
